import React from "react";
import { Layout, MenuProps, Menu, Button, Drawer } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "assets/new-hire-logo.png";
import { PlusOutlined } from "@ant-design/icons";
import { MenuList } from "../config";
import { useIsMobile } from "hooks/useIsMobile";

const { Sider } = Layout;

type SidebarLayoutProps = {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const SidebarLayout = ({ visible, setVisible }: SidebarLayoutProps) => {
  const isMobile = useIsMobile();
  return isMobile ? (
    <MobileSidebar visible={visible} setVisible={setVisible} />
  ) : (
    <DefaultSider visible={visible} setVisible={setVisible} />
  );
};

function DefaultSider({ visible, setVisible }: SidebarLayoutProps) {
  const [selectedKeys, setSelectedKeys] = React.useState<string>("");
  const [openKeys, setOpenKeys] = React.useState<string[]>([]);

  const location = useLocation();
  const navigate = useNavigate();

  const isMobile = useIsMobile();

  const onClick: MenuProps["onClick"] = (e) => {
    navigate(e.key);
    if (isMobile) {
      setVisible(!visible);
    }
  };

  function handleOpenChange(openKeys: string[]) {
    setOpenKeys(openKeys);
  }

  React.useEffect(() => {
    setSelectedKeys(location.pathname);
  }, [location]);

  return (
    <Sider
      width={240}
      theme="light"
      className="h-[100vh] fixed overflow-hidden px-3"
    >
      <div style={{ padding: "0px 0px" }}>
        <img alt="#" src={Logo} width={260} />
      </div>

      <div className="mt-4">
        <Button
          className="h-12 px-8 ms-2  border-2 border-border text-base  flex items-center gap-2 bg-primary text-white border-none w-4/5"
          style={{ width: "90%" }}
          type="primary"
          onClick={() => navigate("/recruiter/post-job")}
        >
          <PlusOutlined />
          Post Job
        </Button>
      </div>

      <Menu
        selectedKeys={[selectedKeys]}
        openKeys={openKeys}
        onOpenChange={handleOpenChange}
        mode="inline"
        items={MenuList}
        style={{ height: "100vh" }}
        onClick={onClick}
      />
    </Sider>
  );
}

function MobileSidebar({ visible, setVisible }: SidebarLayoutProps) {
  const onClose = () => {
    setVisible(false);
  };
  return (
    <>
      <Drawer width={270} placement="left" closable={false} onClose={onClose} open={visible}>
        <DefaultSider visible={visible} setVisible={setVisible} />
      </Drawer>
    </>
  );
}
export default SidebarLayout;
